import React from 'react';
import { FadeIn } from './FadeIn';
interface PageIntroProps {
  eyebrow: string;
  title: string;
  description: string;
}
export function PageIntro({
  eyebrow,
  title,
  description
}: PageIntroProps) {
  return <section className="border-b border-pine/10 bg-cream px-6 pb-16 pt-20 md:px-12 md:pb-20 md:pt-28" data-id="element-468" data-mp="2z76xdvi2szhk">
      <div className="mx-auto max-w-5xl" data-id="element-469" data-mp="3390rfkxrn58r">
        <FadeIn data-id="element-470" data-mp="335wdvwyeux5f">
          <p className="mb-5 text-xs font-medium uppercase tracking-[0.2em] text-clay/70" data-id="element-471" data-mp="3qxjzbzcwlg0b">
            {eyebrow}
          </p>
        </FadeIn>
        <FadeIn delay={0.1} data-id="element-472" data-mp="3vvd6aum16e1n">
          <h1 className="mb-6 max-w-4xl font-serif text-5xl leading-[1.05] text-pine md:text-7xl" data-id="element-473" data-mp="3vuk6yepeiqtj">
            {title}
          </h1>
        </FadeIn>
        <FadeIn delay={0.2} data-id="element-474" data-mp="3mv6xhm1a228t">
          <p className="max-w-2xl text-lg font-light leading-relaxed text-clay md:text-xl" data-id="element-475" data-mp="3muf148zuw0hh">
            {description}
          </p>
        </FadeIn>
      </div>
    </section>;
}